import { Grid2, TableCell } from "@mui/material";
import React, { useState } from "react";
import CommonTable from "../../../candidates/Table";
import CustomMenuItem from "../../../../component/Menu";
import { MoreVertOutlined } from "@mui/icons-material";
import BoxEditIco from "../../../../assets/icons/BoxEditIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import AddDelivery from "./AddDelivery";

export default function KeyDelivery({
  KeyDeliveryHeaderData,
  addDeliveryDialog,
  handleAddDeliveryCloseDialog,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [checkSelected, setCheckSelected] = useState({
    count: 0,
    selected: [],
  });
  const [sortedData, setSortedData] = useState([
    {
      id: "10000",
      projectName:
        "Build a scalable SaaS app using Lightning, Apex, and Flow, integrating third-party tools and automation to streamline workflows.",
      assumption: "See Note",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Develop a scalable SaaS application using Lightning, Apex, and Flow for efficient user experiences. Integrate third-party tools to enhance functionality and optimize business processes.",
          title: "Notes",
          type: "Blank",
        },
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Automate workflows to improve efficiency and reduce manual effort.",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: "10001",
      projectName:
        "Leverage Salesforce Einstein AI for predictive insights, real-time dashboards, and workflow automation to enhance efficiency.",
      assumption: "See Note",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Utilize Salesforce Einstein AI for predictive insights and data-driven decision-making.",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: "10002",
      projectName:
        "Design an intuitive Lightning UI, implement RBAC & Salesforce Shield, and provide seamless onboarding with MyTrailhead.",
      assumption: "",
      notes: [],
    },
  ]);

  const menuData = [
    {
      title: "Add Note",
      image: <BoxEditIco />,
      //   onClick: () => handleEdit(selectedRowData),
      //   onClick: () => handleAddNote(selectedRowData),
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      //   onClick: () => handleDelete(selectedRowData),
    },
  ];

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleIconClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    // setSelectedRowData(rowData);
  };

  const handleTableBodyData = (row, index) => {
    return (
      <>
        <TableCell
          sx={{
            color: row.color ? row.color : "#101828",
            fontWeight: 500,
          }}
        >
          {row.projectName}
        </TableCell>
        <TableCell
          sx={{ color: "#7F56D9", fontWeight: 700 }}
          //   onClick={() => handleSeeNote(row)}
        >
          {row.notes?.length ? "See Comments" : "-"}
        </TableCell>

        <TableCell align="right">
          <MoreVertOutlined
            style={{ cursor: "pointer" }}
            onClick={(e) => handleIconClick(e, row)}
          />
          <CustomMenuItem
            open={open}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
            menuData={menuData}
            boxShadow="0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
          />
        </TableCell>
      </>
    );
  };

  const handleSingleSelect = (row) => {
    setCheckSelected((prev) => {
      const isSelected = prev.selected.some((item) => item.id === row.id);
      const updatedSelected = isSelected
        ? prev.selected.filter((item) => item.id !== row.id)
        : [
            ...prev.selected,
            {
              id: row.id,
              name: row.name,
              type: row.resume_file_name,
              resume_id: row.resume_id,
            },
          ];

      const updatedCount = updatedSelected.length;

      return { selected: updatedSelected, count: updatedCount };
    });
  };

  const handleSelectAll = () => {
    const allIds = sortedData.map((row) => ({
      id: row.id,
      name: row.name,
      type: row.resume_file_name,
      resume_id: row.resume_id,
    }));

    if (
      sortedData.every((row) =>
        checkSelected.selected.some((item) => item.id === row.id)
      )
    ) {
      const deselectedIds = checkSelected.selected.filter(
        (item) => !allIds.some((row) => row.id === item.id)
      );
      setCheckSelected({
        selected: deselectedIds,
        count: deselectedIds.length,
      });
    } else {
      const updatedSelected = [...checkSelected.selected, ...allIds];
      const uniqueSelected = Array.from(
        new Set(updatedSelected.map((item) => item.id))
      ).map((id) => updatedSelected.find((item) => item.id === id));

      setCheckSelected({
        selected: uniqueSelected,
        count: uniqueSelected.length,
      });
    }
  };

  return (
    <Grid2 size={12}>
      <CommonTable
        marginTop={"0px"}
        data={sortedData}
        columns={KeyDeliveryHeaderData}
        onSortChange={(col) => console.log("Sort by", col)}
        //   onRowCheckboxChange={handleRowCheckboxChange}
        handleTableBodyData={handleTableBodyData}
        withCheckbox={true}
        checkSelected={checkSelected.selected}
        handleSingleSelect={handleSingleSelect}
        handleSelectAll={handleSelectAll}
      />
      <AddDelivery
        openDialog={addDeliveryDialog.open}
        handleCloseDialog={handleAddDeliveryCloseDialog}
      />
    </Grid2>
  );
}
